import { cn } from '@workspace/lib';
import type { SanityImage } from '@workspace/interfaces';
import { Picture } from '@/app/common';

interface GalleryThumbnailsProps {
  gallerySlides: SanityImage[];
  emblaRef: (node: HTMLDivElement | null) => void;
  onImageClick: (index: number) => void;
}

export const GalleryThumbnails = ({ gallerySlides, emblaRef, onImageClick }: GalleryThumbnailsProps) => {
  return (
    <div className="w-full overflow-hidden mt-6 md:mt-0" ref={emblaRef}>
      <div className={cn('flex flex-row')}>
        {gallerySlides.map((img, index) => (
          <div key={index} className="shrink-0 md:ml-sm cursor-pointer" onClick={() => onImageClick(index)}>
            <Picture
              image={img}
              alt={img.bynderImage?.alt || img.alt || 'img'}
              desktopWidth={305}
              desktopHeight={305}
              imgClassName="w-[305px] h-[305px] cursor-pointer"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
